import { createApiSlice } from "@common";
import { CRUD_LMS_COMPANY_HOLIDAYS_CONFIG, CRUD_LMS_SITE_CONFIG } from "@routes";

const apiConfig = [
  {
    name: "addCompanyHoliday",
    method: "post",
    url: CRUD_LMS_COMPANY_HOLIDAYS_CONFIG,
    stateKey: "message"
  },
  
  {
    name: "getCompanyHoliday",
    method: "get",
    url: CRUD_LMS_COMPANY_HOLIDAYS_CONFIG,
    stateKey: "data"
  },
   {
    name: "getSiteCompanyHoliday",
    method: "get",
    url:  CRUD_LMS_SITE_CONFIG,
    stateKey: "siteData"
  },
  {
    name: "updateCompanyHoliday",
    method: "put",
    url: CRUD_LMS_COMPANY_HOLIDAYS_CONFIG,
    stateKey: "message"
  },
  {
    name: "deleteCompanyHoliday",
    method: "delete",
    url: CRUD_LMS_COMPANY_HOLIDAYS_CONFIG,
    stateKey: "message"
  },
];

const customReducers = {
  initialState: {
    data: [],
    siteData:[],
    additionalData: []
  },
  reducers: {
    setAdditionalData: (state, action) => { state.additionalData = action.payload; },
  },
  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice(
  "CompanyHoliday",
  apiConfig,
  customReducers
);
const CompanyHolidaySlice = slice;

export default CompanyHolidaySlice.reducer;

export const {
  addCompanyHoliday,
  getCompanyHoliday,
  getSiteCompanyHoliday,
  updateCompanyHoliday,
  deleteCompanyHoliday
} = thunks;
export const { rowSelect } = actions;
